import axios from 'axios'

export default {
  state: {
    error: null,
    showError: false,
    redirect: null
  },
  mutations: {
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SHOW_ERROR(state, show) {
      state.showError = show
    },
    SET_REDIRECT(state, redirect) {
      state.redirect = redirect
    }
  },
  actions: {
    setError({ commit }, error) {
      commit('SET_ERROR', error)
      commit('SET_SHOW_ERROR', true)
    },
    // eslint-disable-next-line no-unused-vars
    warnSlack({ commit }, data){
      if(process.env.VUE_APP_ENV != 'dev')
        axios.post(process.env.VUE_APP_SLACK_HOOK, JSON.stringify({ "text": JSON.stringify(data) }), {
          withCredentials: false,
          transformRequest: [(data, headers) => {
            delete headers.common["X-Authorization"]
            delete headers.common["Authorization"]
            return data
          }]
        })

    },
    forceRedirect({ commit }, dest) {
      commit('SET_REDIRECT', dest)
    },
    clearError({ commit }) {
      commit('SET_SHOW_ERROR', false)
      commit('SET_REDIRECT', null)
    }
  },
  getters: {}
}
